export class HR_Documento{
	public DOCUMENT_iD:number;
	public FILE_ID:number;
	public PERSON_ID:number;
	public TIPODOCUMENTO:number;
	public DOCUMENTO:string;
	public ORIGINALCOPIA:string;
	public urlimagen:string;
	public BASE64:string;
	public FILE_NAME:string;
	public ORIGINAL_FLAG:string;
	public COPY_FLAG:string;
	public DOCUMENT_TYPE:number;
	public anterior:number;
}


// WEBPACK FOOTER //
// ./src/app/models/HR_Documento.ts